import React, { useEffect, useRef, useState } from "react";
import { FaGithub } from "react-icons/fa";
import pill from "../assets/pillimg.jpg";
import driver from "../assets/drowsy.jpeg";
import tryon from "../assets/tryon.png";
import lib from "../assets/lib.jpeg";
import ats from "../assets/ats.webp";
import free from "../assets/free.jpg";
import link from "../assets/link.jpg";
import smart from "../assets/smart.jpg";
import mock from "../assets/mock.png";

function Projects() {
  const portfolios = [
    {
      id: 1,
      src: pill,
      github: "https://github.com/Logiclayer1111/Medicine-Dosage-Tracker",
      title: "Pill-Planner",
      description:
        "A web application that Streamlines and tracks the Medicine Dosage. Helps users manage their medication schedules effectively.",
    },
    {
      id: 2,
      src: tryon,
      github: "https://github.com/Logiclayer1111/Outfit-Assistant",
      title: "AI Virtual Outfit Assistant",
      description:
        "AI Virtual Outfit Assistant is an innovative tool that offers outfit suggestions based on vocation and style preferences. It provides a virtual try-on experience.",
    },
    {
      id: 3,
      src: free,
      github: "https://github.com/Logiclayer1111/Webauthon",
      title: "AI Freelance Job Marketplace",
      description:
        "A modern, AI-powered freelance job platform designed to bridge the gap between skilled professionals and clients looking for top-tier talent. This platform streamlines the process of connecting, collaborating, and contracting, empowering freelancers.",
    },
    {
      id: 4,
      src: ats,
      github: "https://github.com/Logiclayer1111/Application-Tracking-System",
      title: "AI Resume Scanner",
      description:
        "A complete end-to-end Applicant Tracking System (ATS) powered by the Google Gemini Pro Vision API. The system intelligently analyzes your resume, compares it with a given job description, and provides personalized improvement suggestions to help align your profile with the job requirements.",
    },
    {
      id: 5,
      src: mock,
      github: "https://github.com/Logiclayer1111/MockInterviews",
      title: "AI-Powered Mock Interview",
      description:
        "FastTrackHire is an AI-powered mock interview web application built with Python, Streamlit, and LLMs (LLaMA3-8B-8192) . It helps users simulate company-specific interview experiences by analyzing their resume and tailoring questions accordingly. FastTrackHire-makes you hire like a pro!",
    },
    {
      id: 6,
      src: smart,
      github: "https://github.com/Logiclayer1111/Smart_Attendance_System",
      title: "Smart Attendance System",
      description:
        "Smart Attendance System using OpenCV is a facial recognition-based solution that automates attendance by detecting and verifying student faces in real-time. It enhances accuracy, reduces proxy attendance, and eliminates manual entry errors for efficient and accurate attendance tracking and management.",
    },
    {
      id: 7,
      src: link,
      github: "https://github.com/Logiclayer1111/LinkShield",
      title: "AI E-mail Phishing",
      description:
        "The AI E-mail Phishing Detection project uses machine learning algorithms to detect and prevent email phishing attacks. It uses natural language processing to analyze the email content and identify potential phishing indicators in real time. It alerts the user if the email is potentially phishing.",
    },
    {
      id: 8,
      src: driver,
      github: "https://github.com/Logiclayer1111/DrowsyDriverDetection",
      title: "Drowsy Driving Detection",
      description:
        "Improves road safety by alerting drivers showing signs of fatigue. It uses computer vision and machine learning to detect drowsiness in drivers. It alerts the driver if they are drowsy and helps them stay alert and safe on the road. Alarm is generated using pygame and CNN trained on 4000 images.",
    },
    {
      id: 9,
      src: lib,
      github: "https://github.com/Logiclayer1111/library-management",
      title: "Library Management System",
      description:
        "A Library Management System is a digital solution that streamlines book tracking, borrowing, returns, and inventory management for efficient library operations.",
    },
  ];

  return (
    <div
      id="projects"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white min-h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Projects
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-3 md:grid-cols-3 gap-8 px-4 sm:px-0 items-stretch">
          {portfolios.map(({ id, src, github, title, description }) => (
            <ProjectCard
              key={id}
              src={src}
              github={github}
              title={title}
              description={description}
            />
          ))}
        </div>
      </div>

      <style jsx global>{`
        .perspective-1000 {
          perspective: 1000px;
        }

        .transform-style-3d {
          transform-style: preserve-3d;
        }
      `}</style>
    </div>
  );
}

function ProjectCard({ src, github, title, description }) {
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const cardRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleMouseMove = (e) => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      const rotateX = (y - 0.5) * 20;
      const rotateY = (0.5 - x) * 20;

      setRotation({ x: rotateX, y: rotateY });
    }
  };

  const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  useEffect(() => {
    if (descriptionRef.current) {
      setShowToggle(
        descriptionRef.current.scrollHeight >
          descriptionRef.current.clientHeight,
      );
    }
  }, [description]);

  return (
    <div
      ref={cardRef}
      className="perspective-1000 h-full"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="relative h-full transition-transform duration-200 ease-out transform-style-3d"
        style={{
          transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
        }}
      >
        <div className="transform-style-3d flex h-full flex-col bg-gray-900 border border-gray-700 rounded-xl overflow-hidden shadow-lg hover:shadow-xl hover:shadow-cyan-500/20 duration-300">
          <div
            className="transform-style-3d w-full"
            style={{ transform: `translateZ(40px)` }}
          >
            <img src={src} alt={title} className="w-full h-48 object-cover" />
          </div>

          <div
            className="transform-style-3d px-6 pt-4 pb-2"
            style={{ transform: `translateZ(60px)` }}
          >
            <h3 className="text-xl font-bold mb-2 text-white">{title}</h3>
          </div>

          <div
            className="transform-style-3d flex-1 px-6 py-2"
            style={{ transform: `translateZ(50px)` }}
          >
            <p
              ref={descriptionRef}
              className="text-gray-300 text-sm"
              style={
                isExpanded
                  ? undefined
                  : {
                      display: "-webkit-box",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }
              }
            >
              {description}
            </p>
            {showToggle && (
              <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                className="mt-3 text-sm font-medium text-cyan-400 transition-colors duration-200 hover:text-cyan-300"
              >
                {isExpanded ? "Less" : "More"}
              </button>
            )}
          </div>

          <div
            className="transform-style-3d flex items-center justify-center p-4"
            style={{ transform: `translateZ(70px)` }}
          >
            <a
              href={github}
              target="_blank"
              rel="noopener noreferrer"
              className="w-1/2 px-4 py-2 mx-2 bg-gradient-to-r from-gray-700 to-gray-900 border border-gray-600 rounded-lg text-white font-medium hover:scale-105 duration-200 inline-flex items-center justify-center gap-2"
            >
              <FaGithub className="text-lg" />
              GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
